import { NoteComponentAdditionalButtonClickOutput } from '..';

export interface NoteListAdditionalButtonClickOutput {
    noteComponentAdditionalButtonClickOutput: NoteComponentAdditionalButtonClickOutput;
    index: number;
}
